var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera-wrapper"},[_c('video',{ref:"video",staticClass:"camera-video",style:(_vm.videoStyle),attrs:{"autoplay":"","playsinline":"","muted":""},domProps:{"muted":true}}),_vm._m(0),_c('canvas',{ref:"canvas",staticStyle:{"display":"none"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera-overlay"},[_c('div',{staticClass:"face-frame"})])
}]

export { render, staticRenderFns }